import CommonLoader from "../../Utilities/CommonLoader";
import CommonAxios from "../../Utilities/CommonAxios";
import {
    addPrevStock,
    addPurchase,
    chalanDetailUpdate,
    chalanDiscount,
    chalanDiscountWithdraw,
    chalanItemReturn,
    chalanPay,
    chalanPayReturn,
    chalanStock,
    changePurItemCost,
    getAllDueChalan,
    getAllDueChalanWithPagination,
    getDateWiseChalan,
    getDateWiseChalanWithPagination,
    getPendingChalan, getSingleChalanForPrint,
    getSingleChalanForUpdate,
    stockReturn
} from "../../AllRoutes/ApiRoute";
import CommonToast from "../../Utilities/CommonToast";
import { ChalanSlice } from "../Slice/ChalanSlice";

// add purchase action
export const addPurchaseAction = payload => dispatch => {
    // getting parameter from payload
    const {
        data,
        chalanSubmitRef,
        setResetAllByClickNew,
        setPrintDta,
    } = payload

    // button loader handle
    CommonLoader.btn(chalanSubmitRef)

    // db operation
    CommonAxios.post(addPurchase, payload).then(async res => {
        // button loader handle
        CommonLoader.btn(chalanSubmitRef)

        if (res.data.status == true) {
            // reset purchase all form
            setResetAllByClickNew(prev => !prev)
            CommonToast.success("Purchase completed")
            // set data form print
            setPrintDta({ ...res.data.data, clickTime: new Date() })
        } else {
            CommonToast.error("Purchase failed! try again.")
        }

    }).catch(err => {
        // button loader handle
        CommonLoader.btn(chalanSubmitRef)
    })
}

// add prev stock action
export const addPrevStockAction = payload => dispatch => {
    // getting parameter from payload
    const {
        data,
        chalanSubmitRef,
        setResetAllByClickNew,
        setPrintDta,
    } = payload

    // button loader handle
    CommonLoader.btn(chalanSubmitRef)

    // db operation
    CommonAxios.post(addPrevStock, payload).then(async res => {
        // button loader handle
        CommonLoader.btn(chalanSubmitRef)

        if (res.data.status == true) {
            // reset purchase all form
            setResetAllByClickNew(prev => !prev)
            CommonToast.success("chalan mark as previous stock. please stock the chalan.")
            // set data form print
            setPrintDta({ ...res.data.data, clickTime: new Date() })
        } else {
            CommonToast.error("chalan marked failed! try again.")
        }

    }).catch(err => {
        // button loader handle
        CommonLoader.btn(chalanSubmitRef)
    })
}

// getting date wise chalan
export const getDateWiseChalanAction = payload => dispatch => {
    // getting data from payload
    const { allChalanSubmitBtnRef, data, allChalanTableLoaderHandleRef } = payload

    // button loader handler
    CommonLoader.btn(allChalanSubmitBtnRef)
    // handle table section loader
    CommonLoader.section(allChalanTableLoaderHandleRef)

    // db operation
    CommonAxios.silentPost(getDateWiseChalan, payload).then(res => {
        // button loader handler
        CommonLoader.btn(allChalanSubmitBtnRef)
        // handle table section loader
        CommonLoader.section(allChalanTableLoaderHandleRef)

        if (res.data.status == true) {
            dispatch(ChalanSlice.actions.getAllChalanReducer(res.data.data))
        }

    }).catch(err => {
        // button loader handler
        CommonLoader.btn(allChalanSubmitBtnRef)
        // handle table section loader
        CommonLoader.section(allChalanTableLoaderHandleRef)
    })
}

// get date wise challan with pagination
export const getDateWiseChallanWithPaginationAction = payload => dispatch => {
    // getting data from payload
    const { setPaginationDisability } = payload
    // handle pagination disability
    setPaginationDisability(true)
    // db operation
    CommonAxios.silentPost(getDateWiseChalanWithPagination, payload).then(res => {
        // handle pagination disability
        setPaginationDisability(false)
        // set data
        dispatch(ChalanSlice.actions.getAllChallanWithPaginationReducer(res?.data || {}))
    }).catch(e => {
        // handle pagination disability
        setPaginationDisability(false)
    })
}

//get single chalan for print
export const getSingleChalanForPrintAction = payload => dispatch => {
    // getting data from payload
    const {
        printBtnRef,
        setPrintData
    } = payload

    // handle button loader
    CommonLoader.btn(printBtnRef)

    // db operation
    CommonAxios.silentPost(getSingleChalanForPrint, payload).then(async res => {
        // handle button loader
        CommonLoader.btn(printBtnRef)
        await setPrintData({ ...res.data.data, clickTime: new Date() })
    }).catch(err => {
        // handle button loader
        CommonLoader.btn(printBtnRef)
        CommonToast.error("Something went wrong with chalan.")
    })
}

// getting single chalan for update and return
export const getSingleChalanForUpdateAction = payload => dispatch => {
    // getting data from payload
    const { chalanGetFieldRef, setSingleChalanForUpdate } = payload

    // disable field
    chalanGetFieldRef.current.disabled = true

    // db operation
    CommonAxios.post(getSingleChalanForUpdate, payload).then(async res => {
        // enable field
        chalanGetFieldRef.current.disabled = false

        if (res.data.status == true) {
            await setSingleChalanForUpdate({ ...res.data.data, setDataTime: new Date() })
        } else {
            setSingleChalanForUpdate({})
            CommonToast.error("No chalan found!")
        }

    }).catch(err => {
        // enable field
        chalanGetFieldRef.current.disabled = false
    })
}

// getting pending chalan
export const getPendingChalanAction = payload => dispatch => {
    // getting data from payload
    const { pendingChalanSectionLoaderRef } = payload

    // handle section loader
    CommonLoader.section(pendingChalanSectionLoaderRef)

    // db operation
    CommonAxios.get(getPendingChalan).then(res => {
        // handle section loader
        CommonLoader.section(pendingChalanSectionLoaderRef)

        if (res.data.status == true) {
            dispatch(ChalanSlice.actions.getAllPendingChalanReducer(res.data.data))
        }

    }).catch(err => {
        // handle section loader
        CommonLoader.section(pendingChalanSectionLoaderRef)
    })
}

// chalan stock action
export const chalanStockAction = (paylod) => dispatch => {
    // getting data form payload
    const {
        data,
        refreshOnClickSetState,
        currentStockBtnId
    } = paylod

    // stock btn disable
    currentStockBtnId.disabled = true

    // db operation
    CommonAxios.post(chalanStock, paylod).then(async res => {
        // stock btn enable
        currentStockBtnId.disabled = false

        if (res.data.status == true) {
            refreshOnClickSetState(prev => !prev)
            CommonToast.success("Chalan Stocked!")
        } else {
            // stock btn enable
            currentStockBtnId.enable = true
            CommonToast.warning("This chalan has already stocked! refresh your page.")
        }

    }).catch(err => {
        // stock btn enable
        currentStockBtnId.disabled = false
    })
}

// chalan item return aciton
export const chalanItemReturnAction = payload => dispatch => {
    // getting data from payload
    const {
        data,
        chalanItemReturnBtnRef,
        setNewOnClickState,
        chalanGetForUdpateAndReturnOnSubmit,
        chalanGetFieldRef
    } = payload

    // return button loader handle
    CommonLoader.btn(chalanItemReturnBtnRef)

    // db operation
    CommonAxios.post(chalanItemReturn, payload).then(res => {
        // return button loader handle
        CommonLoader.btn(chalanItemReturnBtnRef)

        if (res.data.status == true) {
            // get this chalan and set to the form again in updated possition
            chalanGetFieldRef.current.value = data.chalan_no
            chalanGetForUdpateAndReturnOnSubmit()
            // toast message
            CommonToast.success("Chalan Item return successfully completed!")
        } else {
            // toast message
            CommonToast.error("May-be the chalan already stocked.")
        }
    }).catch(err => {
        // return button loader handle
        CommonLoader.btn(chalanItemReturnBtnRef)
    })

}

// stock item return action
export const stockItemReturnAction = payload => dispatch => {
    // getting data from payload
    const {
        data,
        chalanItemReturnBtnRef,
        setNewOnClickState,
        chalanGetForUdpateAndReturnOnSubmit,
        chalanGetFieldRef
    } = payload

    // return button loader handle
    CommonLoader.btn(chalanItemReturnBtnRef)

    // db operation
    CommonAxios.post(stockReturn, payload).then(res => {
        // return button loader handle
        CommonLoader.btn(chalanItemReturnBtnRef)

        if (res.data.status == true) {
            // get this chalan and set to the form again in updated possition
            chalanGetFieldRef.current.value = data.chalan_no
            chalanGetForUdpateAndReturnOnSubmit()
            // toast message
            CommonToast.success("Stock Item return successfully completed!")
        } else {
            // toast message
            CommonToast.error("May-be the chalan is not stocked.")
        }
    }).catch(err => {
        // return button loader handle
        CommonLoader.btn(chalanItemReturnBtnRef)
    })
}

// chalan item return aciton
export const chalanDetailUpdateAction = payload => dispatch => {
    // getting data from payload
    const {
        data,
        chalanDetailUpdateRef,
        chalanGetFieldRef,
        setNewOnClickState,
        chalanGetForUdpateAndReturnOnSubmit,
    } = payload

    // return button loader handle
    CommonLoader.btn(chalanDetailUpdateRef)

    // db operation
    CommonAxios.post(chalanDetailUpdate, payload).then(res => {
        // return button loader handle
        CommonLoader.btn(chalanDetailUpdateRef)

        if (res.data.status == true) {
            // get this chalan and set to the form again in updated possition
            chalanGetFieldRef.current.value = data.chalan_no
            chalanGetForUdpateAndReturnOnSubmit()
            // toast message
            CommonToast.success("Chalan detail updated successfully!")
        } else {
            // toast message
            CommonToast.error("Chalan detail updated failed!")
        }
    }).catch(err => {
        // return button loader handle
        CommonLoader.btn(chalanDetailUpdateRef)
    })

}

// change item cost action
export const changePurItemCostAction = payload => dispatch => {
    // getting data from payload
    const {
        data,
        costChangeBtnRef,
        chalanGetFieldRef,
        setNewOnClickState,
        chalanGetForUdpateAndReturnOnSubmit,
    } = payload

    // return button loader handle
    CommonLoader.btn(costChangeBtnRef)

    // db operation
    CommonAxios.post(changePurItemCost, payload).then(res => {
        // return button loader handle
        CommonLoader.btn(costChangeBtnRef)

        if (res.data.status == true) {
            // get this chalan and set to the form again in updated possition
            chalanGetFieldRef.current.value = data.chalan_no
            chalanGetForUdpateAndReturnOnSubmit()
            // toast message
            CommonToast.success("Item cost change successfully!")
        } else {
            // toast message
            CommonToast.error("Item cost change failed!")
        }
    }).catch(err => {
        // return button loader handle
        CommonLoader.btn(costChangeBtnRef)
    })
}

// get all due chalan action
export const getAllDueChalanAction = payload => dispatch => {
    const { dueChalanSectionLoaderRef } = payload

    // handle loader
    CommonLoader.section(dueChalanSectionLoaderRef)

    // db operation
    CommonAxios.get(getAllDueChalan).then(res => {
        // handle loader
        CommonLoader.section(dueChalanSectionLoaderRef)

        if (res.data.status == true) {
            dispatch(ChalanSlice.actions.getAllDueChalanReducer(res.data.data))
        }
    }).catch(err => {
        // handle loader
        CommonLoader.section(dueChalanSectionLoaderRef)
    })
}

// get all due chalan with pagination action
export const getAllDueChalanWithPaginationAction = payload => dispatch => {
    // getting data from payload
    const { setPaginationDisability } = payload
    // handle pagination disability
    setPaginationDisability(true)
    // db operation
    CommonAxios.silentPost(getAllDueChalanWithPagination, payload).then(res => {
        // handle pagination disability
        setPaginationDisability(false)
        // set data
        dispatch(ChalanSlice.actions.getAllDueChallanWithPaginationReducer(res?.data || {}))
    }).catch(e => {
        // handle pagination disability
        setPaginationDisability(false)
    })
}

// chalan pay action
export const chalanPayAction = payload => dispatch => {
    const {
        data,
        submitRef,
        setRefreshOnClick,
        setPaymentModalShow
    } = payload

    // handle loader
    CommonLoader.btn(submitRef)

    // db operation
    CommonAxios.post(chalanPay, payload).then(res => {
        // handle loader
        CommonLoader.btn(submitRef)

        if (res.data.status == true) {
            setPaymentModalShow(false)
            setRefreshOnClick(prev => !prev)
            CommonToast.success("chalan payment successfully completed!")
        } else {
            CommonToast.error("chalan payment failed! try again.")
        }
    }).catch(err => {
        // handle loader
        CommonLoader.btn(submitRef)
    })
}
// chalan discount action
export const chalanDiscountAction = payload => dispatch => {
    const {
        data,
        submitRef,
        setRefreshOnClick,
        setPaymentModalShow
    } = payload

    // handle loader
    CommonLoader.btn(submitRef)

    // db operation
    CommonAxios.post(chalanDiscount, payload).then(res => {
        // handle loader
        CommonLoader.btn(submitRef)

        if (res.data.status == true) {
            setPaymentModalShow(false)
            setRefreshOnClick(prev => !prev)
            CommonToast.success("chalan discount successfully adjusted!")
        } else {
            CommonToast.error("chalan discount failed! try again.")
        }
    }).catch(err => {
        // handle loader
        CommonLoader.btn(submitRef)
    })
}

// chalan payment refund action
export const chalanPaymentRefundAction = payload => dispatch => {
    const {
        data,
        submitRef,
        setRefreshOnClick,
        setRefundModalShow
    } = payload

    // handle loader
    CommonLoader.btn(submitRef)

    // db operation
    CommonAxios.post(chalanPayReturn, payload).then(res => {
        // handle loader
        CommonLoader.btn(submitRef)

        if (res.data.status == true) {
            setRefundModalShow(false)
            setRefreshOnClick(prev => !prev)
            CommonToast.success("chalan payment refund successfully adjusted!")
        } else {
            CommonToast.error("chalan payment refund failed! try again.")
        }
    }).catch(err => {
        // handle loader
        CommonLoader.btn(submitRef)
    })
}

// chalan discount withdraw action
export const chalanDiscountWithdrawAction = payload => dispatch => {
    const {
        data,
        submitRef,
        setRefreshOnClick,
        setRefundModalShow
    } = payload

    // handle loader
    CommonLoader.btn(submitRef)

    // db operation
    CommonAxios.post(chalanDiscountWithdraw, payload).then(res => {
        // handle loader
        CommonLoader.btn(submitRef)

        if (res.data.status == true) {
            setRefundModalShow(false)
            setRefreshOnClick(prev => !prev)
            CommonToast.success("chalan discount withdraw successfully adjusted!")
        } else {
            CommonToast.error("chalan disount withdraw failed! try again.")
        }
    }).catch(err => {
        // handle loader
        CommonLoader.btn(submitRef)
    })
}
